module.exports = __webpack_public_path__ + "media/images/spinning-circles-59cc03a8a813914c548a9f2cfc4d3b5b.svg";